import { strings } from '@purple-start-registration/common/localization';
import { REGISTRATION_TYPE } from '@purple-start-registration/common/registration';

export const registrationOptions = (settings) => {
  const options = [];

  if (settings.trial) {
    options.push({
      id: REGISTRATION_TYPE.TRIAL,
      name:
        (settings.trial_sessions == 1 &&
          strings.formatString(
            strings.registrationTypeTrialSingle,
            settings.trial_sessions
          )) ||
        strings.formatString(
          strings.registrationTypeTrial,
          settings.trial_sessions
        ),
    });
  }

  if (settings.per_month) {
    options.push({
      id: REGISTRATION_TYPE.PER_MONTH,
      name: strings.registrationTypePerMonth,
    });
  }

  if (settings.per_session) {
    options.push({
      id: REGISTRATION_TYPE.PER_SESSION,
      name: strings.registrationTypePerSession,
    });
  }

  return options;
};
